import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as types from './actionTypes';
import Swal from 'sweetalert2';
import { post } from 'helpers/api_helper';

function* fetchTimesheetApprovalsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_APPROVALS, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch approvals');
    yield put({ type: types.FETCH_TIMESHEET_APPROVALS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_APPROVALS_FAILURE, payload: error.message });
  }
}

function* fetchTimesheetEmployeeDetailsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_APPROVAL_EMPLOYEE_DETAILS, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch employee timesheet');
    yield put({ type: types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_FAILURE, payload: error.message });
  }
}

function* updateTimesheetApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_UPDATE_TIMESHEET_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to update approval');
    yield put({ type: types.UPDATE_TIMESHEET_APPROVAL_SUCCESS, payload: response.data });
    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    yield put({ type: types.UPDATE_TIMESHEET_APPROVAL_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

function* fetchTimesheetHRApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_HR_APPROVALS, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch HR approvals');
    yield put({ type: types.FETCH_TIMESHEET_HR_APPROVAL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_HR_APPROVAL_FAILURE, payload: error.message });
  }
}

function* generateTimesheetHRApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GENERATE_TIMESHEET_HR_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to generate HR approvals');
    yield put({ type: types.GENERATE_TIMESHEET_HR_APPROVAL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GENERATE_TIMESHEET_HR_APPROVAL_FAILURE, payload: error.message });
  }
}

function* saveGeneratedTimesheetHRApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_GENERATED_TIMESHEET_HR_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to save HR approval');
    yield put({ type: types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_SUCCESS, payload: response.data });
    Swal.fire('Saved', response.message, 'success');
  } catch (error) {
    yield put({ type: types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

function* fetchTimesheetFinalApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_FINAL_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch final approvals');
    yield put({ type: types.FETCH_TIMESHEET_FINAL_APPROVAL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_FINAL_APPROVAL_FAILURE, payload: error.message });
  }
}

function* saveTimesheetFinalApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_TIMESHEET_FINAL_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to save final approval');
    yield put({ type: types.SAVE_TIMESHEET_FINAL_APPROVAL_SUCCESS, payload: response.data });
    Swal.fire('Saved', response.message, 'success');
  } catch (error) {
    yield put({ type: types.SAVE_TIMESHEET_FINAL_APPROVAL_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

// Watcher
export default function* timesheetSaga() {
  yield all([
    takeLatest(types.FETCH_TIMESHEET_APPROVALS_REQUEST, fetchTimesheetApprovalsSaga),
    takeLatest(types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_REQUEST, fetchTimesheetEmployeeDetailsSaga),
    takeLatest(types.UPDATE_TIMESHEET_APPROVAL_REQUEST, updateTimesheetApprovalSaga),
    takeLatest(types.FETCH_TIMESHEET_HR_APPROVAL_REQUEST, fetchTimesheetHRApprovalSaga),
    takeLatest(types.GENERATE_TIMESHEET_HR_APPROVAL_REQUEST, generateTimesheetHRApprovalSaga),
    takeLatest(types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_REQUEST, saveGeneratedTimesheetHRApprovalSaga),
    takeLatest(types.FETCH_TIMESHEET_FINAL_APPROVAL_REQUEST, fetchTimesheetFinalApprovalSaga),
    takeLatest(types.SAVE_TIMESHEET_FINAL_APPROVAL_REQUEST, saveTimesheetFinalApprovalSaga),
  ]);
}
